const moment = require("moment");
import { main as axios, oauth as oauthAxios } from "../axios";
import hostConfig from "@/config/hostResolver";

// axios.interceptors.request.use(
//   async (config) => {
//     let token = await store.dispatch("isLoggedIn");
//     if (token) {
//       config.headers.common["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
const baseUrl = process.env.VUE_APP_USER_URL ?? `${hostConfig.apiBaseUrl}/user-service`;

class UserService {
  getRoles() {
    return axios
      .get(baseUrl + "/users/roles")
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error! ", error.response);
        throw error;
      });
  }
  getRolesByUser(userId) {
    console.log("Getting role for user ", userId);
    return axios
      .get(baseUrl + "/users/roles/assignments/byUser/" + userId)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error! ", error.response);
        throw error;
        // return error;
      });
  }

  updateUser(userId, body, magicLinkToken = null) {
    return (magicLinkToken ? oauthAxios : axios)
      .patch(baseUrl + "/users/profile/" + userId, body)
      .then((response) => {
        console.log(response.data);
        //Prune the returned users for the data we need for the table
        return response.data;
      })
      .catch((error) => {
        console.log("Error! ", error.response);
        throw error;
      });
  }
  deleteUser(userId, params = {}) {
    console.log(`In UserService deleting ${userId}`);
    return axios
      .delete(baseUrl + "/users/" + userId, { params })
      .then((response) => {
        console.log(response);
        //Prune the returned users for the data we need for the table
        return response;
      })
      .catch((error) => {
        console.log("Error! ", error.response);
        return error;
      });
  }
  deleteUsers(userIds, params = {}) {
    console.log("In UserService deleting users bulk");
    return axios
      .delete(baseUrl + "/users/bulk", {
        data: { userIds: userIds },
        params,
      })
      .then((response) => {
        console.log(response);
        //Prune the returned users for the data we need for the table
        return response;
      })
      .catch((error) => {
        console.log("Error! ", error.response);
        return error;
      });
  }
  async userProfileByEmail(magicLinkToken = null, params = {}) {
    try {
      var response = await (magicLinkToken ? oauthAxios : axios).get(
        baseUrl + "/users/profile/email",
        { params }
      );
      // .then((response) => {
      if (response.data.user.length > 0) return response.data.user[0];
      else throw response;
      // })
    } catch (error) {
      console.log("Error fetching user! ", error);
      throw error;
    }
  }
  async userProfileByUserId(userId) {
    try {
      var response = await axios.get(baseUrl + `/users/profile/${userId}`);
      return response.data.user?.[0];
    } catch (error) {
      console.log("Error fetching user profile by userId! ", error);
      throw error;
    }
  }

  uploadProfilePicture(userId, file, clientId) {
    let formData = new FormData();
    formData.append("clientId", clientId);
    formData.append("image", file);
    return axios
      .post(baseUrl + "/users/profilePicture/" + userId, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error fetching user! ", error.response);
        return error;
      });
  }
  deleteProfilePicture(userId, clientId) {
    return axios
      .delete(baseUrl + "/users/profilePicture/" + userId, {
        clientId: clientId,
      })
      .then((response) => {
        return response.data.success;
      })
      .catch((error) => {
        console.log("Error fetching user! ", error.response);
        return error;
      });
  }
  downloadInvestorFile(fileName) {
    return axios
      .get(baseUrl + "/users/investors/download/" + fileName, {
        responseType: "blob",
      })
      .then((response) => {
        console.log("Downloading investor file " + fileName);
        var arr = fileName.split(".");
        var extension = arr[arr.length - 1];
        console.log(extension);
        if (extension === "pptx" || extension === "DOC" || extension === "pdf") {
          var blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
        } else if (extension === "xlsx") {
          blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
        }
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log("Error downloading file ", error);
      });
  }
  downloadCardProductFile(fileName, magicLinkToken = null) {
    return (magicLinkToken ? oauthAxios : axios)
      .get(baseUrl + "/users/cardproduct/download/" + fileName, {
        responseType: "blob",
      })
      .then((response) => {
        console.log("Downloading cardproduct file " + fileName);
        var arr = fileName.split(".");
        var extension = arr[arr.length - 1];
        console.log(extension);
        if (extension === "pptx" || extension === "DOC" || extension === "pdf") {
          var blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
        } else if (extension === "xlsx") {
          blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
        }
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log("Error downloading file ", error);
      });
  }

  getUserSupplemental(userId) {
    return axios
      .get(baseUrl + "/users/supplemental/user/" + userId)
      .then((response) => {
        return response.data.userSupplemental;
      })
      .catch((error) => {
        console.log("Error fetching user supplemental! ", error.response);
        return error;
      });
  }
  bulkUpdateUserSupplemental(array, magicLinkToken = null) {
    const headers = {
      "Content-Type": "application/json",
    };

    return (magicLinkToken ? oauthAxios : axios)
      .post(baseUrl + "/users/supplemental/bulk", array, {
        headers,
      })
      .then((response) => {
        console.log(response);
        return response.data;
      });
  }
  createDebugUserSupplemental(data) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios
      .post(baseUrl + "/users/supplemental/debug", data, {
        headers,
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  bulkUpdateUserCommunicationPreferences(array, magicLinkToken = null) {
    const headers = {
      "Content-Type": "application/json",
    };

    return (magicLinkToken ? oauthAxios : axios)
      .post(baseUrl + "/users/communicationPreferences/bulk", array, {
        headers,
      })
      .then((response) => {
        console.log(response.data);
        return response.data.preference;
      });
  }

  unsubscribeFromCommPreference(context, contextResourceId) {
    const headers = {
      "Content-Type": "application/json",
    };

    return axios
      .post(
        baseUrl +
          "/users/communicationPreferences/unsubscribe/" +
          context +
          "/" +
          contextResourceId,
        {
          headers,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error! ", error.response?.data ?? error);
        throw error;
      });
  }

  async deleteUserBulkCSV(file, params = {}) {
    try {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("marco", "polo");

      for (const [key, value] of formData) {
        console.log(`${key}: ${value}`);
      }

      // Object.keys(fields).forEach(key => {
      //   formData.append(key, fields[key]);
      // });
      let response = await axios.post(baseUrl + "/users/delete/bulk/csv", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params,
      });

      console.log("deletion results ", response.data);
      return response.data;
    } catch (error) {
      console.log("Error creating password user ", error.response.data);
      throw error.response.data || error.response || error;
    }
  } //end deleteUserBulkCSV

  getValuesForUserColumn(column, clientId, includeSubClients) {
    return axios
      .get(baseUrl + "/users/column/values/" + includeSubClients + "/" + clientId + "/" + column)
      .then((response) => {
        return response.data.values;
      })
      .catch((error) => {
        console.log("Error fetching user columns! ", error.response);
        return error;
      });
  }
  resetPassword(email) {
    return axios
      .get(baseUrl + "/users/resetPassword/" + email)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error resetting password! ", error.response);
        return error;
      });
  }
  getUserIpAddress() {
    return axios
      .get("https://api.ipify.org?format=json", {
        transformRequest: (data, headers) => {
          delete headers.common["Authorization"];
          delete headers["Authorization"];
          return data;
        },
      })
      .then((x) => {
        console.log("IP: ", x);
        return x.data;
      });
  }
  async checkUserAuthByEmail(email, query = null) {
    try {
      var response = await axios.get(`${baseUrl}/users/auth/${email}${query ? "?" + query : ""}`);
      // .then((response) => {
      if (response.data.result && response.data.result.rows && response.data.result.rows.length)
        return response.data.result.rows[0];
      else throw response;
      // })
    } catch (error) {
      console.log("Error fetching user! ", error.response || error);
      throw error.response || error;
    }
  }

  // V2 calls
  getUsersV2(params, magicLinkToken = null) {
    return (magicLinkToken ? oauthAxios : axios)
      .get(baseUrl + "/v2/user", { params })
      .then((response) => {
        //Prune the returned users for the data we need for the table
        return response.data;
      })
      .catch((error) => {
        console.log("Error getting users ", error.response);
        throw error.response;
      });
  } //getUsersV2
  searchUsersV2(body = {}, params = {}, magicLinkToken = null) {
    return (magicLinkToken ? oauthAxios : axios)
      .post(baseUrl + "/v2/user/search", body, { params })
      .then((response) => {
        //Prune the returned users for the data we need for the table
        return response.data;
      })
      .catch((error) => {
        console.log("Error searching users ", error.response);
        throw error.response;
      });
  } //searchUsersV2
  getMagicLinkTokenV2(magicLinkId, magicLink) {
    return axios
      .get(`${baseUrl}/v2/magic-link/verify/${magicLinkId}/${magicLink}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error getting magic link data ", error.response);
        throw error.response ? error.response.data || error.response : error;
      });
  } //getMagicLinkTokenV2
  updateUserV2(userId, body, params = {}) {
    return axios
      .patch(`${baseUrl}/v2/user/${userId}`, body, { params })
      .then((response) => {
        //Prune the returned users for the data we need for the table
        return response.data;
      })
      .catch((error) => {
        console.log("Error updating user ", error.response);
        throw error && error.response ? error.response.data || error.response : error;
      });
  } //updateUserV2
  transferUserToClientV2(clientId, userId, params = {}) {
    return axios
      .patch(`${baseUrl}/v2/user/client/${clientId}/${userId}`, undefined, {
        params: {
          ...params,
          source: "web",
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error transferring to new client ", error.response);
        throw error && error.response ? error.response.data || error.response : error;
      });
  } //transferUserToClientV2

  getExportColumns(table) {
    return axios
      .get(`${baseUrl}/v2/export/columns/${table}`)
      .then((response) => {
        return response.data.result.rows;
      })
      .catch((error) => {
        console.log("Error getting CSV columns ", error.response || error);
        throw error.response ? error.response.data || error.response : error;
      });
  } //getExportColumns

  exportDataV2(table, params) {
    return axios
      .get(`${baseUrl}/v2/export/csv/${table}`, {
        responseType: "blob",
        params,
      })
      .then((response) => {
        console.log("Downloading CSV");

        var blob = new Blob([response.data], {
          type: "application/octet-stream",
        });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const filename = `${moment().format("YYYY-MM-DD")}_${table}_Data.csv`;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log("Error downloading file ", error);
        throw error;
      });
  } // exportDataV2

  // V3 calls
  getUsersV3(params, magicLinkToken = null) {
    return (magicLinkToken ? oauthAxios : axios)
      .get(baseUrl + "/v3/user", { params })
      .then((response) => {
        //Prune the returned users for the data we need for the table
        return response.data;
      })
      .catch((error) => {
        console.log("Error getting users ", error.response);
        throw error.response;
      });
  } //getUsersV3

  async getUserProfileV3(magicLinkToken = null, params = {}) {
    try {
      var response = await (magicLinkToken ? oauthAxios : axios).get(
        baseUrl + "/v3/user/profile/email",
        { params }
      );
      // .then((response) => {
      if (response.data.user.length > 0) return response.data.user[0];
      else throw response;
      // })
    } catch (error) {
      console.log("Error fetching user! ", error);
      throw error;
    }
  } // getUserProfileV3

  getMagicLinkTokenV3(magicLinkId, magicLink) {
    return axios
      .get(`${baseUrl}/v3/magic-link/verify/${magicLinkId}/${magicLink}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error getting magic link data ", error.response);
        throw error.response ? error.response.data || error.response : error;
      });
  } //getMagicLinkTokenV3

  async csvToJson(file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(baseUrl + "/v3/file/csv-to-json", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async getUserByEmailV3(email) {
    const response = await axios.get(`${baseUrl}/v3/user/email/${email}`);
    return response.data;
  }

  //--- PENDING USERS ---

  async getPendingUsers({
    status = "Pending",
    limit = 10,
    page = 1,
    search = "",
    sortBy,
    sortOrder,
    clientId,
  }) {
    const params = {
      status,
      limit,
      page,
      search,
      clientId,
    };

    params.sortBy = sortBy || "createdAt";
    params.sortOrder = sortOrder || "asc";

    const response = await axios.get(`${baseUrl}/v3/pending-user`, { params });

    return {
      rows: response.data.result.rows || [],
      totalCount: response.data.result.totalCount || 0,
      totalPages: response.data.result.totalPages || 0,
    };
  }

  async updatePendingUserStatus({ pendingUserIds, status }) {
    const response = await axios.patch(`${baseUrl}/v3/pending-user/status`, {
      pendingUserIds,
      status,
    });
    return {
      success: response.data.result.success,
      count: response.data.result.count,
    };
  }
}

export default new UserService();
